import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';

const FAQSection: React.FC = () => {
  const { t } = useTranslation();
  
  const faqs = [
    {
      question: t('faq.question1.q'),
      answer: t('faq.question1.a')
    },
    {
      question: t('faq.question2.q'),
      answer: t('faq.question2.a')
    },
    {
      question: t('faq.question3.q'),
      answer: t('faq.question3.a')
    },
    {
      question: t('faq.question4.q'),
      answer: t('faq.question4.a')
    },
    {
      question: t('faq.question5.q'),
      answer: t('faq.question5.a')
    },
    {
      question: t('faq.question6.q'),
      answer: t('faq.question6.a')
    }
  ];

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer", 
        "text": faq.answer
      }
    }))
  };

  return (
    <section className="py-20 bg-white">
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>
      
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            {t('faq.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('faq.subtitle')}
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="space-y-6">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-gray-50 rounded-lg p-6 hover:bg-gray-100 transition-colors duration-200">
                <h3 className="text-lg font-semibold text-gray-900 mb-3">
                  {faq.question}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">
            Still have questions? We'd love to help!
          </p>
          <a
            href="https://christreignslab.com/contact"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center bg-sky-900 text-white px-6 py-3 rounded-lg hover:bg-sky-800 transition-colors duration-200 font-semibold"
          >
            Contact Us
          </a>
        </div> */}
      </div>
    </section>
  );
};

export default FAQSection;